// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import PEDialogSegmentArray from './components/PEDialogSegmentArray';

const PEPhoneCallInteraction = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number='1' title="Character Name" instructions='Please enter a name for the character you are having a phone call dialog with.' />
      <Controller 
        control={control}
        name="content.character_name"
        render={({ field }) => (
          <TextField
            {...field}
            className="mt-16 mb-16"
            label="Character Name"
            placeholder="John Doe"
            error={!!errors.content?.character_name}
            helperText={errors.content?.character_name?.message}
            fullWidth
            required
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="Phone Call Dialog Segment" instructions="Add 1 segment per" />      
      <Controller
        control={control}
        name="content.dialog_segments"
        render={({ field }) => <PEDialogSegmentArray inputDir={inputDir} {...{ control, errors }} />}
      />

    </div>
  )
}

export default PEPhoneCallInteraction;